import { DictionaryBoilerTypeAutocomplete } from '../../models';
import { useAutocompleteSource } from '@eas/common-web';
import { EvidenceAPI } from '../../enums';

export function useDictionaryBoilerTypes() {
  return useAutocompleteSource<DictionaryBoilerTypeAutocomplete>({
    url: `${EvidenceAPI.DICTIONARY_BOILER_TYPES}/autocomplete`,
  });
}
